import * as fetch from '../fetch'

export function get_markdown_by_hash(data){
	let hash = data.hash;
	delete data['hash'];
	return fetch.main_public_fetch({
		url: '/markdown/hash/' + hash,
		method: 'get',
		data,
	})
}

export function save_markdown_by_hash(data){
	return fetch.main_private_fetch({
		url: '/user/markdown',
		method: 'post',
		data,
	})
}

export function change_public_user_markdown(data){
	let md_id = data.md_id;
	delete data['md_id'];
	return fetch.main_private_fetch({
		url: '/user/markdown/status/' + md_id,
		method: 'post',
		data,
	})
}

export function remove_user_markdown_batch(data){
	return fetch.main_private_fetch({
		url: '/user/markdown/batch',
		method: 'delete',
		data,
	})
}

export function remove_user_markdown(data){
	let md_id = data.md_id;
	delete data['md_id'];

	return fetch.main_private_fetch({
		url: '/user/markdown/' + md_id,
		method: 'delete',
		data,
	})
}
